<template>
    <div>
        <v-card>
            <div class='preference'>
                <!-- <div class="title-b title">个人偏好</div> -->
                <div class="sub-title" :class="$vuetify.theme.dark ? 'sub-title-d': 'sub-title-l'">
                    <img src="@/assets/img/border.png" alt="">
                    <span>{{$t('preference.title')}}</span>
                </div>
                <div class="select-box">
                    <v-select
                        v-model="timeNum"
                        dense
                        :items="itemsArr"
                        item-value="key"
                        item-text="value"
                        :label="$t('preference.select.title')"
                        outlined
                        :menu-props="{ bottom: true, offsetY: true }">
                    </v-select>
                </div>
                <template v-if="isRouterAlive">
                    <v-row class="ma-3" :class="$vuetify.theme.dark ? 'list-box-d': ''">
                        <v-col cols="12" md="6" lg="6" xl="4" sm="12">
                            <div class="list">
                                <VApply :filter-query="timeNum"></VApply>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="4" sm="12">
                            <div class="list">
                                <VAuthentication :filter-query="timeNum"></VAuthentication>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="4" sm="12">
                            <div class="list">
                                <VCause :filter-query="timeNum"></VCause>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="4" sm="12">
                            <div class="list">
                                <VFacility :filter-query="timeNum"></VFacility>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="4" sm="12">
                            <div class="list">
                                <TimeFrame :filter-query="timeNum"></TimeFrame>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="4" sm="12">
                            <div class="list">
                                <VLocation :filter-query="timeNum"></VLocation>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </div>
        </v-card>
    </div>
</template>

<script>
import VApply from './apply'
import VAuthentication from './authentication'
import VCause from './cause'
import VFacility from './facility'
import TimeFrame from './timeFrame'
import VLocation from './location'

export default {
    components: { VApply, VAuthentication, VCause, VFacility, TimeFrame, VLocation },
    data() {
        return {
            timeNum:1,
            isRouterAlive:true,
            itemsArr: [
                { key: 1, value: this.$t('preference.select.option01') },
                { key: 2, value: this.$t('preference.select.option02') },
                { key: 3, value: this.$t('preference.select.option03') },
                { key: 4, value: this.$t('preference.select.option04') },
                { key: 5, value: this.$t('preference.select.option05') },
                { key: 6, value: this.$t('preference.select.option06') },
            ]
        };
    },
    computed:{

      theme(){
        return this.$vuetify.theme.dark
      }


    },

    mounted() {
      this.$watch('theme', val => {
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      })
    },


  watch:{
        '$parent.collapsed':{
            handler:function(val,old){
              console.log(val)
                if(!val) {
                    this.isRouterAlive = false
                    this.$nextTick(() => (this.isRouterAlive = true))
                }

            }

        }
    },
    methods: {

    },
}
</script>

<style lang='scss' scoped>
.preference {
    // background: #fff;
    box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    padding-bottom: 5px;
    .sub-title {
        font-size: 18px;
        font-weight: 600;
        padding: 8px 0 8px 30px;
        display: flex;
        align-items: center;
        width: 100%;
        border-radius: 6px 6px 0 0;
        margin-bottom: 30px;
        span {
            margin-left: 10px;
        }
    }
    .sub-title-l {
      background: #dce0f9;
      color: #333;
    }
    .sub-title-d {
      border-bottom: 1px solid #f0f0f0;
    }
    .title {
        padding: 25px 40px;
    }
}
// .box {
//     display: flex;
//     margin-bottom: 45px;

    .list {
        background: #FFFFFF;
        box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        height: 330px;
    }
    .list-box-d {
        .list {
          background: #3B355A;
          box-shadow: 0 4px 8px -4px rgb(19 17 32 / 42%) !important;
        }
    }
    // .list:nth-child(2n-1) {
    //     margin-right: 19px;
    // }
    // .list:nth-child(3n) {
    //     margin-left: 19px;
    // }
// }
::v-deep .ant-select-selection--single{
    height: 38px;
    width: 105px;
}
::v-deep .ant-select-selection__rendered{
    line-height: 38px;
    margin-left: 20px;
    color: #999;
    font-size: 13px;
}
::v-deep .ant-select{
    margin-left: 11px;
}
::v-deep .ant-select-arrow{
    right: 20px;
}
.select-box {
    width: 200px;
    margin-left: 24px;
    margin-bottom: -24px;
}
</style>
